import React from "react";
import { IonContent } from "@ionic/react";
import { useRecoilValue, useRecoilValueLoadable } from "recoil";
import { IUser } from "@interfaces/Interfaces";
import { appInfoAtom, deviceInfoAtom, userAtom } from "@state/State";
import DataController from "@controllers/DataController";
import AuthenticationController from "@controllers/AuthenticationController";
import { AppInfo } from "@capacitor/app";
import { DeviceInfo } from "@capacitor/device";

type ErrorBoundaryFallbackProps = {
  error: unknown;
  resetErrorBoundary?: () => void;
};

const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = () => {
  const user = useRecoilValueLoadable<IUser | null>(userAtom);
  const deviceInfo = useRecoilValue<DeviceInfo | null>(deviceInfoAtom);
  const appInfo = useRecoilValue<AppInfo | null>(appInfoAtom);

  const contactSupport = () => {
    const url = "mailto:apps@class.co.uk";
    const subject = "ParaFolio - General Support";

    const body = DataController.supportEmailBody(user.contents?.userData, deviceInfo, appInfo);

    window.open(`${url}?subject=${subject}&body=${body}`, "_blank");
  };

  return (
    <IonContent className="ion-text-center">
      <div className="flex flex-col h-full bg-portfolio-blue relative">
        <div className="flex flex-col items-center justify-center h-full bg-portfolio-blue max-w-app-column mx-auto pl-safe-area-l pr-safe-area-r px-8">
          <h1 className="text-white font-semibold text-xl">{"Oops, an error has occurred!"}</h1>
          <div className="text-white text-lg mt-1">{"Please try again later."}</div>

          <div className="text-white text-base mt-8">
            {"To report an issue, please "}
            <button
              className="underline"
              onClick={contactSupport}
            >
              {"contact support"}
            </button>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="text-white text-base font-semibold tracking-default mt-8 underline"
          >
            {"Refresh"}
          </button>
          {user.state === "hasValue" && user.contents && (
            <button
              onClick={async () => {
                await AuthenticationController.logout();
                window.location.reload();
              }}
              className="text-white text-base font-semibold tracking-default mt-4 underline"
            >
              {"Log out"}
            </button>
          )}
        </div>
      </div>
    </IonContent>
  );
};

export default ErrorBoundaryFallback;
